import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Plot } from "@abaco/portal-global-state/src/modules/global-state/models/Plot";

export default class ExampleVuexModule extends AbacoVuexModule {
    @State({ default: [] }) selectedPlot!: Plot | null;
    @State({ default: null }) results!: any | null;
}
